import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Logo } from "@/components/site/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  useEffect(() => {
    const t = params.get("t") || "";
    if (!t) { setState("invalid"); return; }
    axios.post(`${API}/unsubscribe`, { token: t }).then(() => setState("done")).catch(() => setState("invalid"));
  }, [params]);
  return (
    <main className="min-h-screen bg-[var(--ink)] px-6 py-10 text-white" data-testid="unsubscribe-page">
      <Logo />
      <div className="mx-auto mt-24 max-w-md text-center">
        {state === "loading" && <Loader2 className="mx-auto h-6 w-6 animate-spin text-[var(--teal)]" />}
        {state === "done" && (
          <div data-testid="unsubscribe-success">
            <CheckCircle2 className="mx-auto h-10 w-10 text-[var(--teal)]" />
            <h1 className="mt-6 font-serif-d text-4xl">You're unsubscribed.</h1>
            <p className="mt-4 text-slate-300">You won't get offer emails from Verbulat anymore.</p>
          </div>
        )}
        {state === "invalid" && (
          <div data-testid="unsubscribe-invalid">
            <h1 className="font-serif-d text-4xl">Link not recognised.</h1>
            <p className="mt-4 text-slate-300">Reply to any of our emails and we'll remove you by hand.</p>
          </div>
        )}
      </div>
    </main>
  );
}
